import {vnModule_knockoutJS} from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import {XMLHttpRequestHandler} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {quizzesList_template} from "../components/templates/quizzesList_template";
import {vn_app_zone_notification} from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import {header} from "./header";

declare var ko: any;
declare var page: any;

export class quizzes extends vnModule_knockoutJS {
    protected XHRHdl: XMLHttpRequestHandler;
    protected elementsList: quizzesList_template;
    protected quizImportFile: File | null = null;
    protected quizImportXhr: XMLHttpRequest | null = null;
    protected quizImportValidationXhr: XMLHttpRequest | null = null;

    protected getModuleName() {
        return "quizzes";
    }

    buildContent(): Array<Element> {
        this.elementsList = new quizzesList_template("list", this.viewModel, this);

        let zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        let loadedModule = zoneHeader.loadedModule;
        (<header>loadedModule).setHeaderTitle("Quizzes");

        return [this.elementsList.build()];
    }

    public getBrandId() {
        return this.getVnAppZone().app.params.idBrand;
    }

    public fillPage(): void {
        this.filterList();
    }

    protected filterList(): void {
        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        this.loadingIn(this.elementsList.builtTemplate.children.namedItem("list-results"));
        let brandId = this.getBrandId();
        let usrReq_url: string = `/api/brand/${brandId}/quizzes/get/`;
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(this.elementsList.getViewModelForRequest())]);

        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdl.onReadyStateFunction = this.onFilterRequestReturn;
        this.XHRHdl.execute();
    }

    protected onFilterRequestReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                let responseParsed = JSON.parse(req.request.response);
                obj.updateList(responseParsed);
            });
            obj.loadingOut(obj.elementsList.builtTemplate.children.namedItem("list-results"));
        };
    }

    protected updateList(responseParsed: any): void {
        this.elementsList.setQuizzes(responseParsed.data);

        let execTime = Math.round((new Date().getTime() - this.XHRHdl.requestStartTime) / 1000 * 100) / 100;
        this.elementsList.setResultInfo(responseParsed.totalCount, responseParsed.totalPage, execTime);

        this.viewModel.list.pagination.itemCount(responseParsed.totalCount);
    }

    protected quizzesListReorder(): void {
        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        this.filterList();
    }

    protected paginationOnPageClick(): void {
        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        this.filterList();
    }

    protected filterSimpleOnChange(): void {
        this.viewModel.list.pagination.pageNumber(1);
        this.filterList();
    }

    protected filterSimpleCancel(): void {
        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }
    }

    protected addQuiz(): void {
        page(`/brand/${this.getBrandId()}/categorization/quizzes/add/`);
    }

    protected viewQuiz(id): void {
        page(`/brand/${this.getBrandId()}/categorization/quizzes/view/${id}`);
    }

    public showQuizImportModal(): void {
        this.resetQuizImportState(false);
        this.elementsList.setQuizImportModalVisible(true);
    }

    public selectQuizImportFile(file: File | null): void {
        if (!file) {
            this.removeQuizImportFile();
            return;
        }

        const fileName = file.name || '';
        const fileType = file.type || '';
        const isCsvFile = /\.csv$/i.test(fileName) || fileType === 'text/csv';
        if (!isCsvFile) {
            this.removeQuizImportFile();
            this.sendNotification('Please select a CSV file.', 'alert');
            return;
        }

        this.quizImportFile = file;
        this.elementsList.setQuizImportFileName(fileName);
        this.validateQuizImportFile();
    }

    public removeQuizImportFile(): void {
        this.quizImportFile = null;
        this.abortQuizImportValidationRequest();
        this.elementsList.clearQuizImportFile();
    }

    public importQuizzes(): void {
        if (!this.quizImportFile) {
            this.sendNotification('Please select a CSV file.', 'alert');
            return;
        }

        if (!this.elementsList.isQuizImportValid()) {
            this.sendNotification('Please upload a valid CSV file.', 'alert');
            return;
        }

        if (this.quizImportXhr) {
            this.quizImportXhr.abort();
        }

        const brandId = this.getBrandId();
        const formData = new FormData();
        formData.append('csvFile', this.quizImportFile);

        const xhr = new XMLHttpRequest();
        this.quizImportXhr = xhr;
        xhr.open('POST', `/api/brand/${brandId}/quizzes/import/`, true);
        xhr.responseType = 'json';

        xhr.onload = () => {
            this.quizImportXhr = null;
            this.elementsList.setQuizImportInProgress(false);

            if (xhr.status === 200) {
                this.resetQuizImportState(true);
                this.filterList();
                this.sendNotification('Quizzes import completed successfully');
                return;
            }

            const response = xhr.response || {};
            this.sendNotification(this.getValidationMessages(response, 'Failed to import quizzes.').join(' '), 'error');
        };

        xhr.onerror = () => {
            this.quizImportXhr = null;
            this.elementsList.setQuizImportInProgress(false);
            this.sendNotification('Failed to import quizzes.', 'error');
        };

        xhr.onabort = () => {
            this.quizImportXhr = null;
            this.elementsList.setQuizImportInProgress(false);
        };

        this.elementsList.setQuizImportInProgress(true);
        xhr.send(formData);
    }

    public cancelQuizImport(): void {
        this.abortQuizImportValidationRequest();
        if (this.quizImportXhr) {
            this.quizImportXhr.abort();
        }

        this.resetQuizImportState(true);
    }

    private validateQuizImportFile(): void {
        if (!this.quizImportFile) {
            this.elementsList.setQuizImportValidationState(false, false);
            return;
        }

        this.abortQuizImportValidationRequest();
        this.elementsList.setQuizImportValidationState(true, false);

        const brandId = this.getBrandId();
        const formData = new FormData();
        formData.append('csvFile', this.quizImportFile);

        const xhr = new XMLHttpRequest();
        const validationFile = this.quizImportFile;
        this.quizImportValidationXhr = xhr;
        xhr.open('POST', `/api/brand/${brandId}/quizzes/import/validate/`, true);
        xhr.responseType = 'json';

        xhr.onload = () => {
            if (this.quizImportValidationXhr !== xhr || this.quizImportFile !== validationFile) {
                return;
            }
            this.quizImportValidationXhr = null;

            if (xhr.status === 200) {
                this.elementsList.setQuizImportValidationState(false, true);
                return;
            }

            const response = xhr.response || {};
            this.elementsList.setQuizImportValidationState(false, false, this.getValidationMessages(response));
        };

        xhr.onerror = () => {
            if (this.quizImportValidationXhr !== xhr || this.quizImportFile !== validationFile) {
                return;
            }
            this.quizImportValidationXhr = null;
            this.elementsList.setQuizImportValidationState(false, false, ['Failed to validate CSV file.']);
        };

        xhr.onabort = () => {
            if (this.quizImportValidationXhr !== xhr) {
                return;
            }
            this.quizImportValidationXhr = null;
        };

        xhr.send(formData);
    }

    private abortQuizImportValidationRequest(): void {
        if (!this.quizImportValidationXhr) {
            return;
        }

        this.quizImportValidationXhr.abort();
        this.quizImportValidationXhr = null;
    }

    private resetQuizImportState(closeModal: boolean): void {
        this.abortQuizImportValidationRequest();
        this.quizImportFile = null;
        this.elementsList.resetQuizImportForm();

        if (closeModal) {
            this.elementsList.setQuizImportModalVisible(false);
        }
    }

    private getValidationMessages(response: any, fallbackMessage: string = 'CSV file validation failed.'): Array<string> {
        const validations = response && response.validations ? response.validations : [];
        let messages = [];

        if (response && response.message) {
            messages.push(response.message);
        }

        for (const validation of validations) {
            if (validation && validation.messages) {
                messages = messages.concat(validation.messages);
            }
        }

        return messages.length ? messages : [fallbackMessage];
    }

    private sendNotification(message: string, type: 'success' | 'alert' | 'error' = 'success') {
        this.getVnAppZone().notification = new vn_app_zone_notification(type, message);
        this.getVnAppZone().showNotificationToModule();
    }
}



// WEBPACK FOOTER //
// ./js/modules/quizzes.ts